import { AppState } from '../../..';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { toggleModal } from '@common/components/common.actions';
import { ModalProps } from '@common/components';
import {
  VendorDocumentTableComponent,
  VendorDocumentTableComponentProperties
} from './vendor-document-table.component';
import { DocumentViewModel, FileViewModel } from '@models/Document';
import { VendorViewModel } from '@models/Vendor';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: {
    vendorVm: VendorViewModel;
    fileList: DocumentViewModel[];
    uploadCallback: (fileVMs: FileViewModel[], vendor: VendorViewModel) => void;
    removeCallback: (fileId: number, vendor: VendorViewModel) => void;
    uploadModalTitle: string;
    removeModalTitle: string;
    canRemove?: boolean;
  }
): Partial<VendorDocumentTableComponentProperties> {
  return {
    vendorVm: ownProps.vendorVm,
    fileList: ownProps.fileList,
    uploadCallback: ownProps.uploadCallback,
    removeCallback: ownProps.removeCallback,
    uploadModalTitle: ownProps.uploadModalTitle,
    removeModalTitle: ownProps.removeModalTitle,
    isLoading: state.vendor.isLoading,
    canRemove: ownProps.canRemove
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<VendorDocumentTableComponentProperties> {
  return {
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const VendorTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorDocumentTableComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-documents/vendor-document-table.container.ts